(function () {
  if (window.__unitMainBannerParallaxInit) {
    window.__unitMainBannerParallaxInit();
    return;
  }

  var ticking = false;

  function update() {
    ticking = false;
    var containers = document.querySelectorAll('[data-unit-main-banner-parallax="true"]');

    containers.forEach(function (container) {
      container.style.removeProperty('--unit-main-banner-parallax-shift');
    });
  }

  function requestTick() {
    if (ticking) {
      return;
    }
    ticking = true;
    window.requestAnimationFrame(update);
  }

  document.addEventListener('shopify:section:load', requestTick);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', requestTick, { once: true });
  } else {
    requestTick();
  }

  window.__unitMainBannerParallaxInit = requestTick;
})();
